/* eslint-disable no-restricted-syntax -- framework */
/**
 * DO NOT EXPORT THIS FILE IN INDEX.TS
 * THERE IS NO REASON FOR WEBAPP OR ANYTHING ELSE TO KNOW ABOUT THIS
 */
import { inject, InjectionToken } from '@angular/core';
import { CrudService, ServiceConfiguration } from '@safarilaw-webapp/shared/crud';
import { SquirrelValue } from '../squirrel-value/models/app/squirrel-value';

import { AppConfigurationService } from '@safarilaw-webapp/shared/environment';
import { ApplicationInsightsService } from '@safarilaw-webapp/shared/logging';
import { SquirrelValueAdapter } from '../squirrel-value/adapters/squirrel-value-adapter';

export const SQUIRREL_VALUE_SERVICE_TOKEN = new InjectionToken<CrudService<SquirrelValue>>('SQUIRREL_VALUE_SERVICE', {
  providedIn: 'root',
  factory: () =>
    new CrudService<SquirrelValue>(inject(SquirrelValueAdapter), inject(ApplicationInsightsService), new ServiceConfiguration(inject(AppConfigurationService).urls.apiRootSquirrel, 'values/{0}'))
});
/*** BEWARE OF DOG - DO NOT DELETE OR PUT ANYTHING ELSE BELOW THIS ***/
